module.exports = __webpack_public_path__ + "img/add-filter.228d2da4.png";